import React, { useState } from 'react';
import {
  SignUpNow,
  SignUpGSTDetails,
  WithoutGstin,
  CompanyDetailsScreen,
  ContactDetailsScreen,
  BusinessCategory,
  YourIndustry,
  LoadingScreen,
  RegistredScreen,
  ErrorScreen,
  ContactUsScreen,
} from '@zonofi/gandalf-components';
import { useLoginSignupScreen } from '@zonofi/gandalf-utilities';
import './login-signup-screen.scss';
import { SignupSplashScreen } from '../signup-splash-screen/signup-splash-screen';

const LoginSignupScreen: React.FC = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const {
    navigate,
    stepFromPath,
    onUpdateValue,
    sellerDetails,
    gstError,
    setGstError,
    validateGST,
    isValidatingGST,
    resetData,
    handleGoBackFromCompanyDetails,
    onRegister,
    isRegistering,
    errorObj,
    closeErrorToast,
    handleLaunchApp,
    isLaunching,
    setSellerDetails,
  } = useLoginSignupScreen();
  const renderStep = () => {
    console.log('i am rendering step');
    switch (stepFromPath) {
      case 'get-started':
      case 'signup-get-started':
        return (
          <SignupSplashScreen
            onUpdateValue={onUpdateValue}
            setSellerDetails={setSellerDetails}
          />
        );
      case 'signup':
      case 'login':
      case 'verifyOtp':
        console.log('i am rendering otp step');
        return (
          <SignUpNow
            isWorkspaceApiLoading={false}
            onUpdateValue={onUpdateValue}
            sellerDetails={sellerDetails}
            onOtpVerified={() => {
              console.log('i am rendering otp verified');
              navigate('/withoutGstin', { replace: true });
              // navigate('/gstDetails', { replace: true });
            }}
          />
        );
      case 'gstDetails':
        return (
          <SignUpGSTDetails
            setShowWithoutGstin={() => {
              setGstError('');
              navigate('/withoutGstin');
            }}
            sellerDetails={sellerDetails}
            onUpdateValue={onUpdateValue}
            validateGST={validateGST}
            isValidatingGST={isValidatingGST}
            gstErrorMessage={gstError}
          />
        );
      case 'withoutGstin':
        return (
          <WithoutGstin
            goBack={() => navigate(-1)}
            navigateToBusinessCategory={() => navigate('/businessCategory')}
            setShowContactDetails={() => navigate('/contactDetails')}
            sellerDetails={sellerDetails}
            onUpdateValue={onUpdateValue}
            validateGST={validateGST}
          />
        );
      case 'companyDetails':
        return (
          <CompanyDetailsScreen
            goBack={handleGoBackFromCompanyDetails}
            setShowContactDetails={() => {
              resetData();
              navigate('/contactDetails');
            }}
            sellerDetails={sellerDetails}
            onUpdateValue={onUpdateValue}
            navigateToBusinessCategory={() => navigate('/businessCategory')}
          />
        );
      case 'contactDetails':
        return (
          <ContactDetailsScreen
            goBack={() => navigate(-1)}
            setBusinessCategory={() => {
              navigate('/businessCategory');
            }}
            sellerDetails={sellerDetails}
            onUpdateValue={onUpdateValue}
          />
        );
      case 'businessCategory':
        return (
          <BusinessCategory
            goBack={() => navigate(-1)}
            setYourIndustry={() => navigate('/yourIndustry')}
            sellerDetails={sellerDetails}
            onUpdateValue={onUpdateValue}
          />
        );
      case 'yourIndustry':
        return (
          <YourIndustry
            goBack={() => navigate(-1)}
            setPlanBusiness={() => navigate('/planBusiness')}
            onRegister={() => {
              onRegister();
              navigate('/loading');
            }}
            sellerDetails={sellerDetails}
            onUpdateValue={onUpdateValue}
            isRegistering={isRegistering}
            errorObj={errorObj}
            closeErrorToast={closeErrorToast}
          />
        );

      case 'loading':
        return <LoadingScreen />;
      case 'launch':
        return (
          <RegistredScreen
            sellerDetails={sellerDetails}
            handleContinue={handleLaunchApp}
            isLoading={isLaunching}
          />
        );
      case 'ERROR':
        return <ErrorScreen />;
      case 'CONTACT_US':
        return <ContactUsScreen />;
      default:
        return null;
    }
  };

  return (
    <div
      className="sign-up"
      style={{
        flex: 1,
      }}
    >
      {!imageLoaded && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f0f0f0',
            zIndex: 1,
          }}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          />
        </div>
      )}
      <img
        src={`https://zono-digital-qa-media-public.s3.ap-south-1.amazonaws.com/seller-web-app-images/signup-bg.svg`}
        alt=""
        className="sign-up-background"
        onLoad={() => setImageLoaded(true)}
      />
      {renderStep()}
    </div>
  );
};

export { LoginSignupScreen };
